import dayjs from 'dayjs'

const WALL = 'YYYY-MM-DD HH:mm'
const MIN_AHEAD_MS = 3600_000

/** 解析 ISO 为本地时区 dayjs（供 DatePicker value） */
export function parseSchedule(iso: string | null | undefined) {
  return iso ? dayjs(iso) : null
}

/** 展示用本地时间 */
export function formatSchedule(iso: string | null | undefined): string {
  return iso ? dayjs(iso).format(WALL) : '—'
}

/** DatePicker 选中的本地时间 → ISO（精确到分钟） */
export function scheduleIsoFromPicker(
  d: dayjs.Dayjs | null | undefined,
): string | null {
  if (!d) return null
  return d.second(0).millisecond(0).toISOString()
}

/** 定时上线须晚于当前至少 1 小时 */
export function isScheduleAtLeastOneHourAhead(
  iso: string,
  nowMs: number = Date.now(),
): boolean {
  return dayjs(iso).valueOf() > nowMs + MIN_AHEAD_MS
}

type ScheduleNowOpts = { nowMs?: number }

function resolveNowMs(opts?: ScheduleNowOpts): number {
  return typeof opts?.nowMs === 'number' ? opts.nowMs : Date.now()
}

/** DatePicker：禁用整日都早于「当前 + 1 小时」的日期（本地时间） */
export function disabledScheduleDate(
  current: dayjs.Dayjs,
  opts?: ScheduleNowOpts,
): boolean {
  const min = dayjs(resolveNowMs(opts) + MIN_AHEAD_MS)
  return current.isBefore(min, 'day')
}

/** DatePicker：在「当前 + 1 小时」当日禁用不足的时分（本地时间） */
export function disabledScheduleTime(
  current: dayjs.Dayjs | null,
  opts?: ScheduleNowOpts,
) {
  if (!current) return {}
  const limit = resolveNowMs(opts) + MIN_AHEAD_MS
  const min = dayjs(limit)
  if (!current.isSame(min, 'day')) return {}

  const minHour = min.hour()

  return {
    disabledHours: () => Array.from({ length: minHour }, (_, h) => h),
    disabledMinutes: (hour: number) => {
      if (hour > minHour) return []
      if (hour < minHour) {
        return Array.from({ length: 60 }, (_, m) => m)
      }
      return Array.from({ length: 60 }, (_, m) => m).filter(
        (m) =>
          current.hour(hour).minute(m).second(0).millisecond(0).valueOf() <=
          limit,
      )
    },
  }
}
